/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketSlaSummaryResponse } from '../../models/ticket-sla-summary-response';

export interface TicketControllerGetTicketSlaSummary$Params {
  show_only_closed_tickets?: boolean;
  show_only_opened_tickets?: boolean;
  selected_date?: string;
}

export function ticketControllerGetTicketSlaSummary(http: HttpClient, rootUrl: string, params?: TicketControllerGetTicketSlaSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketSlaSummaryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerGetTicketSlaSummary.PATH, 'get');
  if (params) {
    rb.query('show_only_closed_tickets', params.show_only_closed_tickets, {});
    rb.query('show_only_opened_tickets', params.show_only_opened_tickets, {});
    rb.query('selected_date', params.selected_date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketSlaSummaryResponse;
      }>;
    })
  );
}

ticketControllerGetTicketSlaSummary.PATH = '/ticket/ticket-sla-summary';
